<template>
  <div class="item-list-wrap">
    <div v-for="(list,k) in itemMessagedata">
      <div v-if="k == 0" class="first-img-rel-wrap" @click="previewClick(list)">
        <template v-if="checkObjSize(itemMessagedata) == 1">
          <div class="img-rel-wrap">
            <img :src="formatImage(list.image,400)">
          </div>
          <div class="single-img-title-wrap">
            <p class="img-title" :data-account-number="list.accountNumber" :data-file-id="list.fileId" :data-msg-id="list.msgId">{{list.title}}</p>
            <div class="get-btn" @click.stop="fetchArticleClick(list)">抓取</div>
          </div>
        </template>
        <template v-else="">
          <div class="img-rel-wrap">
            <img :src="formatImage(list.image,400)">
          </div>
          <div class="img-title-wrap">
            <p class="img-title" :data-account-number="list.accountNumber" :data-file-id="list.fileId" :data-msg-id="list.msgId">{{list.title}}</p>
            <div class="get-btn" @click.stop="fetchArticleClick(list)">抓取</div>
          </div>
        </template>
      </div>
      <div v-else class="list-module clearfix" @click="previewClick(list)">
        <div class="img-title fleft" :data-account-number="list.accountNumber" :data-file-id="list.fileId" :data-msg-id="list.msgId">{{list.title}}</div>
        <div class="img-rel-wrap fleft">
          <img :src="formatImage(list.image,100)">
        </div>
        <div class="get-btn fleft" @click.stop="fetchArticleClick(list)">抓取</div>
      </div>
    </div>
    <div class="preview-modal-bg" v-if="preview" @click="preview = !preview"></div>
    <div class="preview-modal-wrap" v-if="preview" :style="contentStyle">
      <div class="preview-modal-content" v-html="htmlContent"></div>
    </div>
  </div>
</template>
<script type="text/babel">
  import {formatImageByQiniu} from 'UTILS/_url'


  export default {
    data(){
      return {
        preview:false,
        htmlContent:"",//预览内容
        modal:{
          visible:false,
          item: {},//这里是添加,categoryList为空
          name:"",
          itemCategorylist: []
        }
      }
    },
    props:{
      itemMessagedata:{
        type:[Object,Array],
        default:null
      },
      itemCategorylist:{
        type:[Object,Array],
        default:null
      }
    },
    methods: {
      //抓取点击
      fetchArticleClick(data) {
        this.$emit("subscribe-click",data)
      },
      //预览点击
      previewClick(data){
        this.contentStyle = {
          height: (window.innerHeight - 200) + 'px',
        },
        this.preview = true;
        let params = {
          accountNumber:data.accountNumber,
          fileId:data.fileId,
          msgId:data.msgId
        }
        HttpRequest.post("/admin.php?method=wechat.previewArticle",params, true).then((response) => {
          this.htmlContent = response.data.htmlContent;
        }, (response) => {});
      },
      checkObjSize(data){
        return _.size(data)
      },
      formatImage(image,width){
        return formatImageByQiniu(image,width)
      }
    }
  }
</script>
<style lang="less" scoped>
  .preview-modal-bg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    z-index: 5500;
  }
  .preview-modal-wrap{
    width: 750px;
    position:fixed;
    margin:auto;
    left:0;
    right:0;
    top:0;
    bottom:0;
    z-index: 5501;
    background-color: #fff;
    border-radius: 5px;
    .preview-modal-content{
      padding: 20px;
      height: 100%;
      display: block;
      overflow-y: scroll;;
    }
  }
.item-list-wrap{
  cursor: pointer;
  .first-img-rel-wrap{
    width: 340px;
    display: inline-block;
    overflow: hidden;
    position: relative;
    .img-rel-wrap{
      width: 340px;
      height: 180px;
      display: inline-block;
      overflow: hidden;
    }
    .img-title-wrap{
      background: rgba(0,0,0,0.3);
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 5px;
      padding: 5px 10px;
      height: 60px;
      .img-title{
        color: #fff;
        font-size: 16px;
        width: 250px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .get-btn{
        cursor: pointer;
        color: #fff;
        background: #8a5899;
        display: inline-block;
        width: 60px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 8px;
        position: absolute;
        right: 16px;
        bottom: 10px;
      }
    }
    .single-img-title-wrap{
      padding: 10px;
      position: relative;
      height: 60px;
      .img-title{
        font-size: 16px;
        width: 250px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .get-btn{
        cursor: pointer;
        border: 2px solid #8a5899;
        color: #8a5899;
        display: inline-block;
        width: 60px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 8px;
        position: absolute;
        right: 10px;
        bottom: 13px;
      }
    }
  }
  .list-module{
    cursor: pointer;
    height: 70px;
    padding: 10px 0;
    border-top: 1px solid #efefef;
    position: relative;
    .img-title{
      font-size: 14px;
      width: 200px;
      color: #69707a;
      position: absolute;
      left: 0%;
      top: 50%;
      transform: translate(-0%,-50%);
      -webkit-transform: translate(-0%,-50%);
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .img-rel-wrap{
      width: 50px;
      height: 50px;
      display: inline-block;
      overflow: hidden;
      position: absolute;
      left: 72%;
      top: 50%;
      transform: translate(-72%,-50%);
      -webkit-transform: translate(-72%,-50%);
    }
    .get-btn{
      cursor: pointer;
      border: 2px solid #8a5899;
      color: #8a5899;
      display: inline-block;
      width: 60px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 8px;
      position: absolute;
      left: 96%;
      top: 50%;
      transform: translate(-96%,-50%);
      -webkit-transform: translate(-96%,-50%);
    }
  }

}
</style>
